import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Bold } from '#src/atoms/typography/Bold/index.tsx';
import { BodyM, HeadlineL } from '#src/atoms/typography/index.tsx';

const Content = styled(Vertical).attrs({ gap: 2 })`
  height: 100%;
`;

const List = styled.ul`
  padding-left: var(--double-unit);
  display: flex;
  flex-direction: column;
  gap: var(--unit);
  margin: 0;

  li {
    list-style-type: disc;
  }
  ul {
    padding-left: var(--triple-unit);
    li {
      list-style-type: circle;
    }
  }
`;

export const MangopayScaIntro = () => {
  return (
    <Content>
      <HeadlineL as="h3">
        <FormattedMessage defaultMessage="Secure your Sorare account with Mangopay" />
      </HeadlineL>
      <BodyM>
        <FormattedMessage defaultMessage="Complete a one-time Strong Customer Authentication (SCA) with our trusted payment partner, Mangopay." />
      </BodyM>
      <BodyM>
        <FormattedMessage defaultMessage="This verification is:" />
      </BodyM>
      <List>
        <li>
          <BodyM>
            <FormattedMessage
              defaultMessage="<strong>Mandatory and secure</strong> — it protects your account and your funds."
              values={{
                strong: Bold,
              }}
            />
          </BodyM>
        </li>
        <li>
          <BodyM>
            <FormattedMessage
              defaultMessage="<strong>Quick (~1 min)</strong> — you’ll confirm just three things:"
              values={{
                strong: Bold,
              }}
            />
          </BodyM>
        </li>
        <List>
          <li>
            <BodyM>
              <FormattedMessage
                defaultMessage="<strong>Your email address</strong> (mandatory)"
                values={{
                  strong: Bold,
                }}
              />
            </BodyM>
          </li>
          <li>
            <BodyM>
              <FormattedMessage
                defaultMessage="<strong>A new 6-digit PIN</strong> (mandatory)"
                values={{
                  strong: Bold,
                }}
              />
            </BodyM>
          </li>
          <li>
            <BodyM>
              <FormattedMessage
                defaultMessage="<strong>One additional method of your choice:</strong> either your phone number or a trusted device / security key"
                values={{
                  strong: Bold,
                }}
              />
            </BodyM>
          </li>
        </List>
      </List>
    </Content>
  );
};
